import React from 'react';
import PropTypes from 'prop-types';

import { IMAGE, VIDEO } from 'constants/appConstants';

import styles from 'styles/components/reviews/reviewGalleryImage.scss';

const ReviewGalleryImage = ({ review: { reviewGalleryMedia }, reviewMediaIndex }) => {
  const { mediaType, msaMediaUrl } = reviewGalleryMedia[reviewMediaIndex];

  return (
    <div className={styles.bigOverlayImageWrapper}>
      {mediaType === IMAGE && (
        <a href={msaMediaUrl} target="_blank" rel="noopener noreferrer">
          <img src={msaMediaUrl} className={styles.bigOverlayImage} alt="uploaded by customer" />
        </a>
      )}
      {mediaType === VIDEO && (
        <video className={styles.bigOverlayVideo} src={msaMediaUrl} controls />
      )}
    </div>
  );
};

ReviewGalleryImage.propTypes = {
  review: PropTypes.shape({
    reviewGalleryMedia: PropTypes.array.isRequired
  }).isRequired,
  reviewMediaIndex: PropTypes.number.isRequired
};

export default ReviewGalleryImage;
